import type { VoidFunctionComponent } from 'react';

import TooltipBadge from '../../../generic/Badge/TooltipBadge';
import { icons } from '../../../generic/Icon/icons';
import { IconText } from '../../../generic/Icon/index';

type SnippetsBadgeProps = {
  issueId: number;
};

/**
 * Visual indicator for when an issue is derived from a snippet.
 */
const SnippetsBadge: VoidFunctionComponent<SnippetsBadgeProps> = ({ issueId }) => (
  <TooltipBadge
    id={`snippets-issue-badge-tooltip-${issueId}`}
    tooltip="This issue was discovered from a code snippet"
    color="white"
    placement="right"
    showTooltip
  >
    <IconText
      icon={icons.receipt}
      text="Snippet"
    />
  </TooltipBadge>
);

export default SnippetsBadge;
